export default function BulkChangeAssetTypesConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  assetDataService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleConfirmChange = _handleConfirmChange;

  /** *********************************************
   * Event Handlers
   */

  function _handleCloseDialog($event) {
    _closeDialog($event);
  }

  function _handleConfirmChange($event) {
    loaderService.showViewLoader = true;
    return assetDataService.bulkChangeAssetTypes(vm.newAssetTypeId, vm.assetIds).then(() => {
      alerts.success('All Asset Types were successfully changed.');      
      if (vm.updateCallBack) {
        vm.updateCallBack();
      }
      _closeDialog($event);
    }).catch(() => {
      alerts.error('An error occurred while changing the Asset Types.');
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  /** *********************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.assetAdmin.bulkChangeAssetTypesConfirmDialog);
  }
}

BulkChangeAssetTypesConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'assetDataService',
  'loaderService',
  'ssDialogService'
];
